import { useTranslation } from 'react-i18next';
import { Dropdown } from '@/components/ui/Dropdown';
import { LANGUAGES, LanguageCode } from '@/i18n/languages';

/**
 * Output-language picker for the AI agents (Compose / Brief / Compare / Audit).
 * Offers all 14 supported languages — the same set as the app-chrome language
 * switcher — since the model can write its answer in any of them. Use
 * `defaultOutputLanguage()` to seed it from the user's current UI language.
 */
export function OutputLanguageSelect({
  value,
  onChange,
  size = 'md',
  className = 'w-full',
}: {
  value: LanguageCode;
  onChange: (next: LanguageCode) => void;
  size?: 'sm' | 'md';
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <Dropdown<LanguageCode>
      value={value}
      onChange={onChange}
      items={LANGUAGES.map((l) => ({
        value: l.code,
        label: l.nativeName,
        leading: <span aria-hidden>{l.flag}</span>,
      }))}
      ariaLabel={t('common.output_language', { defaultValue: 'Output language' }) as string}
      size={size}
      className={className}
    />
  );
}
